module.exports = __webpack_public_path__ + "img/deepak_sir_thumbnail.6d5dda07.jpg";